export default "varying vec2 vUv;\nvoid main() {\n    vUv = uv;gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n    }"